(() => {
  const track = document.querySelector('#looks-track');
  const cards = [...track.children];
  const prev = document.querySelector('#looks-prev');
  const next = document.querySelector('#looks-next');
  const count = document.querySelector('#looks-count');
  const mobile = matchMedia('(max-width:700px)');
  let current = 0;
  function update() {
    const left = track.getBoundingClientRect().left;
    current = cards.reduce((best, card, i) => Math.abs(card.getBoundingClientRect().left-left) < Math.abs(cards[best].getBoundingClientRect().left-left) ? i : best, 0);
    count.textContent = `${current+1} / ${cards.length}`;
    prev.disabled = current === 0;
    next.disabled = current === cards.length-1;
  }
  function move(index) {
    if (!mobile.matches) return;
    const card = cards[Math.max(0, Math.min(cards.length-1,index))];
    track.scrollTo({left:track.scrollLeft+card.getBoundingClientRect().left-track.getBoundingClientRect().left,behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth'});
  }
  prev.addEventListener('click',()=>move(current-1));
  next.addEventListener('click',()=>move(current+1));
  track.addEventListener('scroll',update,{passive:true});
  track.addEventListener('keydown',e=>{if(mobile.matches && ['ArrowLeft','ArrowRight','Home','End'].includes(e.key)){e.preventDefault();move(e.key==='Home'?0:e.key==='End'?cards.length-1:current+(e.key==='ArrowRight'?1:-1));}});
  window.addEventListener('resize',update);
  update();
})();
